import React from "react";

const Rating = ({ value }) => {
  return (
    <div className="c-Rating">
      <i className="material-icons">{value >= 1 ? "star" : "star_border"}</i>
      <i className="material-icons">{value >= 2 ? "star" : "star_border"}</i>
      <i className="material-icons">{value >= 3 ? "star" : "star_border"}</i>
      <i className="material-icons">{value >= 4 ? "star" : "star_border"}</i>
      <i className="material-icons">{value >= 5 ? "star" : "star_border"}</i>
    </div>
  );
};

export default Rating;



// WEBPACK FOOTER //
// ./src/lib/components/Rating.jsx